import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import "./assets/scss/modern.scss";

import Session from "components/LM/Auth/Session";
import store from "./redux/store/index";
import Routes from "./routes/Routes";
import Loader from "components/Loader";

const App = () => {

  const [loading, setLoading] = useState(true);
  useEffect(() => {
  	const session = new Session();

  	const authenticationStatus = async () => {
      const currentUrl = new URL(window.location.href);
      const regex = RegExp('^(/bsso|/error)');
      if (!regex.test(currentUrl.pathname)) {
    		const response = await session.areWeAuthenticated();
    		if (!response.status) {
          window.location.href = process.env.REACT_APP_BSSO_URL + '/?next=' + encodeURIComponent(currentUrl.href) + '&connect=' + encodeURIComponent(currentUrl.origin + '/bsso/connect');
    		} else {
          await session.fetch();
          if (!session.hasPermission('access')) {
            window.location.href = currentUrl.origin + '/error/401';
          } else {
            setLoading(false);
            session.gainsights();
          }
        }
  		} else {
        setLoading(false);
      }
  	}
  	authenticationStatus();
  }, []);

  return <Provider store={store}>
    {loading ? <Loader /> : <Routes />}
  </Provider>
};

export default App;
